export default {
    inquiry: 'คำขอ',
    cancel: 'ยกเลิก',
    save: 'บันทึก',
    profile: 'ข้อมูลส่วนตัว',
    name: 'ชื่อ - นามสกุล',
    status: 'สถานะ',
    department: 'แผนก',
    statusStart: 'วันเริ่มส่งคำขอ',
    group: 'กลุ่ม',
    personalLeave: 'ลากิจ',
    quota: 'โควต้า',
    used: 'ใช้ไปแล้ว',
    sickLeave: 'ลาป่วย',
    onSite: 'เข้าหน้างาน',
    count: 'จำนวน(คร้้ง)',
    startStatus: 'สถานะเริ่ม',
    endStatus: 'สถานะสิ้นสุด',
    inquiryStatus: 'สถานะคำขอ',
    description: 'คำอธิบาย',
    approve: 'อนุมัติ',
    reject: 'ไม่อนุมัติ',
    contact: 'ติดต่อ',
    emailAddress: 'อีเมล์',
    phoneNumber: 'เบอร์โทรศัพท์',
    congratulation: 'ยินดีด้วย',
    redirecting: 'รอสักครู่',
    returnToInuiry: 'หน้านี้จะเปลี่ยนไปยังหน้าคำร้องขออัตโนมัติ ภายใน 3 วินาที',
    applicationStatus: 'สถานะการร้องขอของ',
    isUpdated: ' มีการอัปเดตเเล้ว หน้านี้จะกลับไปยังหน้าร้องขอโดยอัตโนมัติภายใน 3 วินาที',
    attachment: 'ไฟล์เเนบ',
    checkInLocation: 'สถานที่ลงชื่อเข้างาน',
    amTime: 'น.',
    pmTime: 'น.'
}
